module.exports = __webpack_public_path__ + "static/media/ic_help.4e95ad4e.png";